import React, { useState } from 'react';
import '../../style/WebTables.css'


const WebTables = () => {
  // 1. Initial Table Data State
  const [tableData, setTableData] = useState([
   { id: 1, firstName: "Cierra", lastName: "Vega", age: 39, email: "cierra@example.com", salary: 10000, dept: "Insurance" },
  { id: 2, firstName: "Alden", lastName: "Cantrell", age: 45, email: "alden@example.com", salary: 12000, dept: "Compliance" },
  { id: 3, firstName: "Kierra", lastName: "Gentry", age: 29, email: "kierra@example.com", salary: 2000, dept: "Legal" },
  { id: 4, firstName: "Brandon", lastName: "Stevens", age: 33, email: "brandon@example.com", salary: 8000, dept: "Finance" },
  { id: 5, firstName: "Sasha", lastName: "Banks", age: 27, email: "sasha@example.com", salary: 7000, dept: "Marketing" },
  { id: 6, firstName: "Darius", lastName: "Ford", age: 40, email: "darius@example.com", salary: 15000, dept: "IT" },
  { id: 7, firstName: "Tiana", lastName: "Harris", age: 31, email: "tiana@example.com", salary: 9000, dept: "Operations" },
  { id: 8, firstName: "Malik", lastName: "Reed", age: 36, email: "malik@example.com", salary: 11000, dept: "Compliance" },
  { id: 9, firstName: "Nina", lastName: "Brooks", age: 28, email: "nina@example.com", salary: 6000, dept: "HR" },
  { id: 10, firstName: "Omar", lastName: "Simmons", age: 42, email: "omar@example.com", salary: 13000, dept: "Finance" },
  { id: 11, firstName: "Lara", lastName: "Cole", age: 34, email: "lara@example.com", salary: 8500, dept: "Marketing" },
  { id: 12, firstName: "Travis", lastName: "Russell", age: 30, email: "travis@example.com", salary: 7200, dept: "IT" },
  { id: 13, firstName: "Jada", lastName: "Bell", age: 26, email: "jada@example.com", salary: 5000, dept: "Legal" },
  { id: 14, firstName: "Ethan", lastName: "Morris", age: 37, email: "ethan@example.com", salary: 11500, dept: "Operations" },
  { id: 15, firstName: "Chloe", lastName: "Perry", age: 32, email: "chloe@example.com", salary: 9500, dept: "Insurance" },
  { id: 16, firstName: "Dante", lastName: "Watson", age: 38, email: "dante@example.com", salary: 10500, dept: "Finance" },
  { id: 17, firstName: "Maya", lastName: "Reynolds", age: 29, email: "maya@example.com", salary: 7800, dept: "HR" },
  { id: 18, firstName: "Zane", lastName: "Hughes", age: 41, email: "zane@example.com", salary: 12500, dept: "IT" },
  { id: 19, firstName: "Alina", lastName: "Foster", age: 33, email: "alina@example.com", salary: 8800, dept: "Marketing" },
  { id: 20, firstName: "Leo", lastName: "Hayes", age: 35, email: "leo@example.com", salary: 9700, dept: "Compliance" },
  { id: 21, firstName: "Sienna", lastName: "Ward", age: 27, email: "sienna@example.com", salary: 6200, dept: "Legal" },
  { id: 22, firstName: "Kai", lastName: "Brooks", age: 39, email: "kai@example.com", salary: 10800, dept: "Operations" },
  { id: 23, firstName: "Lila", lastName: "Fleming", age: 31, email: "lila@example.com", salary: 8300, dept: "Finance" },
  { id: 24, firstName: "Jasper", lastName: "Mcdonald", age: 44, email: "jasper@example.com", salary: 13500, dept: "IT" },
  { id: 25, firstName: "Amara", lastName: "Holland", age: 28, email: "amara@example.com", salary: 6900, dept: "Marketing" }

  ]);

  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // 2. Save Logic (Handles both Add and Edit)
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    
    const newUser = {
      id: selectedUser ? selectedUser.id : Date.now(), // Unique ID
      firstName: formData.get("firstname"),
      lastName: formData.get("lastname"),
      email: formData.get("email"),
      age: formData.get("age"),
      salary: formData.get("salary"),
      dept: formData.get("deparment"),
    };

    if (selectedUser) {
      // Update existing row
      setTableData(tableData.map(user => user.id === selectedUser.id ? newUser : user));
    } else {
      // Add new row to the list
      setTableData([...tableData, newUser]);
    }

    setShowModal(false);
    setSelectedUser(null);
  };

  return (
    <div className="table-container">
      <h1 className="mb-3 fw-normal border-bottom pb-2 mb-4">Web Tables</h1>
      
      <div className="d-flex justify-content-between align-items-center mb-3">
        {/* ADD BUTTON */}
        <button 
          type="button" 
          className="btn-add" 
          onClick={() => { setSelectedUser(null); setShowModal(true); }}
        >
          Add
        </button>
        
        <div className="input-group" style={{ width: '300px' }}>
          <input className="form-control" type="text" placeholder="Type to Search" />
          <button className="btn btn-outline-secondary" type="button">🔍</button>
        </div>
      </div>

      {/* TABLE */}
      <div className="table-responsive border rounded">
        <table className="custom-table">
          <thead>
            <tr>
              <th>First Name</th><th>Last Name</th><th>Age</th>
              <th>Email</th><th>Salary</th><th>Department</th><th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row) => (
              <tr key={row.id}>
                <td>{row.firstName}</td><td>{row.lastName}</td><td>{row.age}</td>
                <td>{row.email}</td><td>{row.salary}</td><td>{row.dept}</td>
                <td className="text-center">
                  <button className="btn-edit" onClick={() => { setSelectedUser(row); setShowModal(true); }}>Edit</button> | <button className="btn-delete" 
  onClick={() => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      setTableData(tableData.filter(u => u.id !== row.id));
    }
  }}> Del</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* REGISTRATION MODAL POPUP */}
      {showModal && (
        <div className="custom-modal-overlay">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{selectedUser ? "Edit User" : "Registration Form"}</h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="mb-3 row">
                    <label className="col-sm-4 col-form-label">First Name:</label>
                    <div className="col-sm-8">
                      <input name="firstname" type="text" placeholder="Enter First Name" className="form-control" defaultValue={selectedUser?.firstName || ""} required />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-4 col-form-label">Last Name:</label>
                    <div className="col-sm-8">
                      <input name="lastname" type="text" placeholder="Enter Last Name"  className="form-control" defaultValue={selectedUser?.lastName || ""} required />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-4 col-form-label">Email:</label>
                    <div className="col-sm-8">
                      <input name="email" type="email"  placeholder="Enter Email ID" className="form-control" defaultValue={selectedUser?.email || ""} required />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-4 col-form-label">Age:</label>
                    <div className="col-sm-8">
                      <input name="age" type="number" placeholder="Enter Age" className="form-control" defaultValue={selectedUser?.age || ""} required />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-4 col-form-label">Salary:</label>
                    <div className="col-sm-8">
                      <input name="salary" type="number" placeholder="Enter Salary" className="form-control" defaultValue={selectedUser?.salary || ""} required />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-4 col-form-label">Department:</label>
                    <div className="col-sm-8">
                      <input name="deparment" type="text" placeholder="Enter Department" className="form-control" defaultValue={selectedUser?.dept || ""} required />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary w-100">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}


      
    </div>
  );
};

export default WebTables;